import React from "react"
import TextCell, { TextCellProps } from "./TextCell"
import { ContentfulProduct } from "../../../../graphql-types"

type DistanceCellProps = TextCellProps & {
  product: ContentfulProduct
}

export default function DistanceCell({
  product,
  value: _value,
  ...props
}: DistanceCellProps) {
  const min = product.minDistance
  const max = product.maxDistance
  let value = "N/A"
  if (min && min >= 0 && max && max >= -1) {
    if (max === -1) {
      value = `${min} or more  miles`
    } else {
      value = `${min} - ${max} miles`
    }
  } else if (min && min >= 0) {
    value = `At least ${min} miles`
  } else if (max && max >= 0) {
    value = `At most ${max} miles`
  }

  return <TextCell value={value} {...props} />
}
